import { generatePath } from 'react-router-dom';

import axiosClient from '@/shared/axios';
import { LIVESCORING, LIVESCORING_BANNER } from '@/shared/constants/endpoints';

export const getFinishedGames = ({ uuid, page }) => {
  return axiosClient.get(generatePath(LIVESCORING.FINISHED, { uuid, page }));
};

export const searchFinishedGames = ({ uuid, page, query }) => {
  return axiosClient.post(LIVESCORING.SEARCH_FINISHED, {
    uuid,
    page,
    needle: query,
  });
};

export const getTopScores = ({ uuid }) => {
  return axiosClient.get(generatePath(LIVESCORING.TOP_SCORES, { uuid }));
};

export const getLivescoringBanner = () => {
  return axiosClient.get(LIVESCORING_BANNER);
};
